import * as React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './components/sidebar';

function App(): JSX.Element {
  return <Sidebar content={<Outlet />} />;
}

export default App;
